module.exports = __webpack_public_path__ + "img/guilherme_s.1d32001e.jpeg";